/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_StagesInputs */

const cs_pipelines_stages = /** @type {(inputs: Pipelines_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fáze`)
};

const en_pipelines_stages = /** @type {(inputs: Pipelines_StagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stages`)
};

/**
* | output |
* | --- |
* | "Stages" |
*
* @param {Pipelines_StagesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_stages = /** @type {((inputs?: Pipelines_StagesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_StagesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_stages(inputs)
	return cs_pipelines_stages(inputs)
});